import React from 'react';
import AccountManagement from './index';

/**
 * AccountMenu component that directly renders the AccountManagement component
 * Used as a component for direct URL access to account management
 */
const AccountMenu = () => {
  return <AccountManagement />;
};

export default AccountMenu;
